export function getAerialViewContent() {
  return {
    title: 'Виды\xa0вокруг\xa0жилого\xa0комплекса\xa0—\xa0панорамная\xa0съемка',
  };
}
